export default __webpack_public_path__ + "static/media/onboard-bankinfo-img.80c9f14d.png";